<template>
  <div>
    <Head title="Gestão de profissionais" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Gestão de profissionais</h1>
      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        search-label="Pesquisar por nome, e-mail ou CPF"
        route="professionals/list"
        no-data-label="Nenhum profissional de saúde cadastrado"
        no-result-label="Nenhum profissional de saúde encontrado"
      >
        <template #table.cell.content.professional_status="{ value, row }">
          <div v-if="row.status">Ativo</div>
          <div v-if="!row.status">Inativo</div>
          <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
        </template>
        <template #grid.content.body.professional_status="{ value, row }">
          <div v-if="row.status">Ativo</div>
          <div v-if="!row.status">Inativo</div>
          <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 gap-4 ">
            <span @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-primary text-lg cursor-pointer" /></span>
            <span @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-2" /><span class=""> Adicionar Profissional</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable" />
    <modal-edit ref="modalEdit" :modal-scrollable="true" title="Profissional" url="professionals" :item="{user: {}, group: null, specialty: null, errors: {user: {}}}" :multipart="true" @submitForm="reloadTable">
      <template #form="{item}">
        <photo-input v-model="item.user.photo" :error="item.errors[`user.photo`]" class="lg:pr-6 w-full lg:w-1/2" type="file" label="Foto" />
        <div class="hidden lg:block lg:w-1/2" />
        <text-input v-model="item.user.name" :error="item.errors[`user.name`]" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Nome" />
        <mask-input v-model="item.cpf" mask="###.###.###-##" :error="item.errors.cpf" class="lg:pr-6 mt-6 w-full lg:w-1/4" label="CPF" />
        <mask-input v-model="item.cnpj" mask="##.###.###/####-##" :error="item.errors.cnpj" class="mt-6 w-full lg:w-1/4" label="CNPJ" />
        <date-input v-model="item.birthdate" :error="item.errors.birthdate" class="mt-6 w-full lg:pr-6 lg:w-1/3" label="Data de Nascimento" />
        <select-input v-model="item.sex" :error="item.errors.sex" class="mt-6 w-full lg:pr-6 lg:w-1/3" label="Gênero">
          <option :value="null" />
          <option v-for="(value, name, index) in sex_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <mask-input v-model="item.phone_mobile" :mask="['(##) #####-####']" :clear-incomplete="true" :error="item.errors.phone_mobile" class="mt-6 w-full lg:w-1/3" label="Celular" />
        <email-input v-model="item.user.email" :error="item.errors[`user.email`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" label="E-mail" />
        <password-input v-model="item.user.password" :error="item.errors[`user.password`]" class="mt-6 w-full lg:w-1/2" label="Senha" />
        <vue-select-input
          v-model="item.specialties"
          :multiple="true"
          :options="getFilteredSpecialties(item)"
          :error="item.errors.specialties"
          class="mt-6 lg:pr-6 w-full lg:w-1/2"
          label="Especialidade"
          text="nenhuma especialidade encontrada"
        />

        <vue-select-input
          v-model="item.type_service"
          :multiple="true" :searchable="false"
          :="type_services"
          :error="item.errors.type_service"
          class="mt-6 w-full lg:w-1/2 hidden"
          label="Tipo de atendimento"
          text="nenhum tipo de atendimento encontrado"
        />
        <div v-if="!item.specialties.length" class="mt-6 hidden lg:block lg:w-1/2" />
        <div v-if="item.specialties.length" class="mt-6 flex flex-col text-center w-full lg:w-1/2">
          <div class="flex flex-nowrap bg-gray-100/50 p-4">
            <div class="w-full lg:w-1/2">Especialidade</div>
            <div class="w-full lg:w-1/2">RQE</div>
          </div>
          <div v-for="(specialty, specialty_index) in item.specialties" class="flex flex-nowrap px-4 py-2">
            <div class="w-full lg:w-1/2">{{ specialty.name }}</div>
            <div class="w-full lg:w-1/2">
              <text-input v-model="specialty.rqe" :error="item.errors[`specialties.`+specialty_index+`.rqe`]" class="w-full" />
            </div>
          </div>
        </div>
        <select-input v-model="item.class_entity" :error="item.errors.class_entity" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Conselho profissional">
          <option :value="null" />
          <option v-for="(value, name, index) in class_entity_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <text-input v-model="item.class_number" :error="item.errors.class_number" class="mt-6 lg:pr-6 w-full lg:w-1/3" label="Número do órgão" />
        <select-input v-model="item.uf" :error="item.errors.uf" class="mt-6 w-full lg:w-1/3" label="UF">
          <option :value="null" />
          <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
        </select-input>
        <div class="hidden lg:block lg:w-1/2" />
        <textarea-input v-model="item.about" :error="item.errors.about" class="mt-6 w-full" label="Sobre" />
        <switch-input v-model="item.status" class="w-full mt-6 lg:w-1/4" label="Situação" label-checked="Ativo" label-unchecked="Inativo" @click="checkInactive($event, item)" />
        <div class="w-3/4 hidden lg:block" />
        <div v-if="item.try_inactive && item.appointments_in_progress.length" class="mt-6">
          Este profissional possui agendamento(s) em aberto, para Inativar deve selecionar o profissional que irá assumir esse(s) agendamento(s).
        </div>
        <switch-input v-if="item.appointments_in_progress.length" v-model="item.migrate_appointments" class="w-full mt-6 lg:w-2/4" label-checked="Migrar agendamentos" label-unchecked="Migrar agendamentos" @click="checkMigrate($event, item)" />
        <div v-if="item.appointments_in_progress.length" class="w-2/4 hidden lg:block" />
        <div v-if="item.migrate_appointments && item.appointments_in_progress.length" class="mt-6">
          <div class="mt-6 flex flex-col text-center">
            <div class="flex flex-nowrap bg-gray-100/50 p-4">
              <div class="w-full lg:w-1/4">Data</div>
              <div class="w-full lg:w-1/4">Paciente</div>
              <div class="w-full lg:w-1/4">Especialidade</div>
              <div class="w-full lg:w-1/4">Profissional</div>
            </div>
            <div v-for="(appointment, index) in item.appointments_in_progress" class="flex flex-nowrap p-4">
              <div class="w-full lg:w-1/4">{{ $filters.formatDate(appointment.date_start) }} {{ appointment.date_start.substr(10, 6) }} - {{ appointment.date_end.substr(10, 6) }}</div>
              <div class="w-full lg:w-1/4">{{ appointment.patient.user.name }}</div>
              <div class="w-full lg:w-1/4">{{ appointment.specialty.name }}</div>
              <div class="w-full lg:w-1/4">
                <select-input v-model="appointment.professional_id" :error="item.errors[`appointments_in_progress.`+index+`.professional_id`]" class="w-full" @change="checkForInactive(item)">
                  <option v-for="(professional, index) in professionals_appointments[appointment.id]" :key="professional.id" :value="professional.id">{{ professional.user.name }}</option>
                </select-input>
                <div v-if="item.appointments_in_progress.length > 1 && appointment.professional_id" class="mt-2">
                  <button type="button" class="btn-primary text-xs px-4 py-1" @click.prevent="applyAllProfessional(item, appointment)">Aplicar em todos</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="mt-6 flex items-end font-roboto font-medium btn-primary uppercase" @click.prevent="item.addresses.push({state: null});">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Endereço
        </button>
        <div v-for="(address, address_index) in item.addresses" class="w-full flex flex-wrap p-6 mt-4 bg-gray-100/50 relative">
          <cep-input v-model="address.postcode" :error="item.errors[`addresses.`+address_index+`.postcode`]" class="pr-6 w-11/12 lg:w-3/12" placeholder="CEP" @updateAddress="(...args) => onUpdateAddress(address,...args)" />
          <text-input v-model="address.street" :error="item.errors[`addresses.`+address_index+`.street`]" class="mt-6 lg:pr-6 w-full lg:w-8/12 lg:mt-0" placeholder="Logradouro" />
          <div class="mt-4 lg:mt-0 w-1/12 self-center text-right absolute lg:relative top-4 lg:top-0 right-6 lg:right-0">
            <span @click="deleteAddress(item, address)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
          </div>
          <text-input v-model="address.number" :error="item.errors[`addresses.`+address_index+`.number`]" class="mt-6 w-full lg:w-1/3 lg:pr-6" placeholder="Número" />
          <text-input v-model="address.complement" :error="item.errors[`addresses.`+address_index+`.complement`]" class="mt-6 w-full lg:w-2/3" placeholder="Complemento" />

          <text-input v-model="address.neighborhood" :error="item.errors[`addresses.`+address_index+`.neighborhood`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" placeholder="Bairro" />
          <text-input v-model="address.city" :error="item.errors[`addresses.`+address_index+`.city`]" class="mt-6 lg:pr-6 w-full lg:w-1/3" placeholder="Cidade" />
          <select-input v-model="address.state" :error="item.errors[`addresses.`+address_index+`.state`]" class="mt-6 w-full lg:w-1/3" placeholder="Estado">
            <option :value="null" disabled class="hidden invisible">Estado</option>
            <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
          </select-input>
          <text-input v-model="address.cnes" :error="item.errors[`addresses.`+address_index+`.cnes`]" class="mt-6 lg:pr-6 w-full lg:w-1/2" placeholder="CNES" />
          <mask-input v-model="address.phone" :mask="['(##) ####-####', '(##) #####-####']" :clear-incomplete="true" :error="item.errors[`addresses.`+address_index+`.phone`]" class="mt-6 w-full lg:w-1/2" placeholder="Telefone" />
        </div>
      </template>
    </modal-edit>
    <modal ref="modalDeleteInactive" :modal-scrollable="true" :modal-backdrop="true">
      <template #body>
        <div class="text-center">
          <font-awesome-icon icon="fa-trash-can" class="text-red-600 text-2xl" />
          <div class="mt-4 mb-4">
            Este profissional possui agendamento(s) em aberto, o profssional deve ser inativado para poder ser excluído.
          </div>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="$refs.modalDeleteInactive.showModal = false">Ok</button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>

import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import Modal from '@/Shared/Modal/Modal'
import DataTable from '@/Shared/Components/DataTable'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import EmailInput from '@/Shared/Fields/EmailInput'
import TextareaInput from '@/Shared/Fields/TextareaInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import SelectInput from '@/Shared/Fields/SelectInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import PhotoInput from '@/Shared/Fields/PhotoInput'
import CepInput from '@/Shared/Fields/CepInput'
import PercentualInput from '@/Shared/Fields/PercentualInput'
import DateInput from '@/Shared/Fields/DateInput'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    Modal,
    DataTable,
    SwitchInput,
    TextInput,
    EmailInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
    TextareaInput,
    PhotoInput,
    CepInput,
    PercentualInput,
    DateInput,
  },
  layout: Layout,
  props: {
    states_options: Object,
    class_entity_options: Object,
    sex_options: Object,
    professionals: Array,
  },
  setup() {

  },
  data() {
    return {
      professionals_appointments: {},
      specialties: [],
      groups: [],
      loadTable: true,
      columns: [
        {
          uniqid: 'professional_name',
          label: 'Nome',
          field: 'users.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.name}`,
        },
        {
          uniqid: 'professional_specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialties_labels ? row.specialties_labels : '',
        },
        {
          uniqid: 'professional_email',
          label: 'E-mail',
          field: 'users.email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
          format: (val, row) => `${row.user.email}`,
        },
        {
          uniqid: 'professional_cpf',
          label: 'CPF',
          field: 'cpf',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'professional_class_number',
          label: 'Registro de classe',
          field: 'class_number',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.class_number ? row.class_entity_label + ': ' + row.class_number  + '-' + row.uf : '',
        },
        {
          uniqid: 'professional_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status
      this.$inertia.post('/professionals/update-status', {id: item.id, status: item.status})
    },
    openModalConfirmDelete(item) {
      if(item.appointments_in_progress.length) {
        this.$refs.modalDeleteInactive.showModal = true
      } else {
        this.$refs.modalDelete.openModalDelete(item, `/professionals/${item.id}`, `Deseja realmente excluir o profissional de saúde ${item.user.name}?`)
      }
    },
    openModalEdit(i) {
      let item = {
        id: i.id,
        class_entity: i.class_entity,
        class_number: i.class_number,
        uf: i.uf,
        type_service: i.type_service,
        cpf: i.cpf,
        cnpj: i.cnpj,
        sex: i.sex,
        birthdate: i.birthdate,
        phone_mobile: i.phone_mobile,
        about: i.about,
        commission: i.commission,
        specialties: i.specialties ?? [],
        addresses: i.addresses ?? [],
        appointments_in_progress: i.appointments_in_progress ?? [],
        status: i.status ?? true,
        user: {
          photo: {},
        },
        migrate_appointments: false,
        try_inactive: false,
      }
      if(i.user) {
        item.user = {
          id: i.user.id,
          name: i.user.name,
          email: i.user.email,
          photo: {
            name: i.user.photo?.name,
            size: i.user.photo?.size,
            url: i.user.photo?.url,
          },
        }
      }
      if(item.appointments_in_progress) {
        for(let i in item.appointments_in_progress) {
          let appointment = item.appointments_in_progress[i]
          this.professionals_appointments[appointment.id] = []
          this.professionals_appointments[appointment.id].push({
            id: '',
            user: {
              name: 'Selecione',
            },
          })
          this.filterProfessionals(item, appointment)
        }
      }
      this.$refs.modalEdit.openModalEdit(item)
    },
    reloadTable() {
      this.loadTable = false
      setTimeout(() => this.loadTable = true, 10)
    },
    async loadOptions() {
      await fetch(
        'professionals/get-options',
      ).then(res => {
        res.json().then(json => {
          this.specialties = json.specialties
          this.type_services = json.type_services
        })
      })
    },
    deleteAddress(form, address) {
      form.addresses.splice(form.addresses.indexOf(address), 1)
    },
    onUpdateAddress(address, json) {
      address.city = json.localidade
      address.state = json.uf
      address.street = json.logradouro
      address.neighborhood = json.bairro
    },
    applyAllProfessional(item, appointment) {
      for(let i in item.appointments_in_progress) {
        let apt = item.appointments_in_progress[i]
        let professional = this.professionals.find(professional => professional.id == appointment.professional_id && professional.specialties.filter(specialty => specialty.id == apt.specialty_id).length && this.professionals_appointments[apt.id].filter(prof_appt => prof_appt.id == professional.id).length)
        if(professional) {
          apt.professional_id = appointment.professional_id
        }
      }
      this.checkForInactive(item)
    },
    async filterProfessionals(professional, appointment) {
      let token = this.$page.props.csrf_token
      for(let i in this.professionals) {
        let prof = this.professionals[i]
        if(prof.id !== professional.id && prof.specialties.filter(specialty => specialty.id == appointment.specialty_id).length) {
          const rawResponse = await fetch('professionals/check-time', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-Token': token,
            },
            body: JSON.stringify({
              date_start: appointment.date_start,
              date_end: appointment.date_end,
              professional_id: prof.id,
            }),
          })
          const content = await rawResponse.json()
          if(content.allowed) {
            this.professionals_appointments[appointment.id].push(prof)
          }
        }
      }
      return this.professionals_appointments[appointment.id]
    },
    checkInactive(e, item) {
      if(item.appointments_in_progress.length) {
        if(!e.target.checked) {
          item.try_inactive = !item.try_inactive
          if(!item.try_inactive && item.migrate_appointments) {
            let hasWithProfessional = item.appointments_in_progress.filter(appointment => appointment.professional_id?.length > 0).length > 0
            if(!hasWithProfessional) {
              item.migrate_appointments = false
            }
          } else if(item.try_inactive) {
            item.migrate_appointments = true
          }
          let hasWithoutProfessional = item.appointments_in_progress.filter(appointment => appointment.professional_id?.length == 0).length > 0
          if(hasWithoutProfessional) {
            e.target.checked = true
          }
        } else {
          item.try_inactive = false
        }
      }
    },
    checkForInactive(item) {
      setTimeout(function(){
        if(item.try_inactive && item.appointments_in_progress.length) {
          let hasWithoutProfessional = item.appointments_in_progress.filter(appointment => appointment.professional_id?.length == 0).length > 0
          if(hasWithoutProfessional) {
            item.status = true
          } else {
            item.status = false
          }
        }
      }, 100)
    },
    checkMigrate(e, item) {
      if(!e.target.checked) {
        this.clearMigrate(item)
      }
    },
    clearMigrate(item) {
      for(let i in item.appointments_in_progress) {
        let apt = item.appointments_in_progress[i]
        apt.professional_id = ''
      }
      this.checkForInactive(item)
    },
    getFilteredSpecialties(item) {
      if (!item || !item.specialties) return this.specialties
      return this.specialties.filter(
        specialty => !item.specialties.some(selected => selected.id === specialty.id)
      );
    }
  },
}
</script>
